module.exports = "<nv-react-component component=\"TeamFacilitationComponent\" render-if=\"TeamFacilitationComponent\"></nv-react-component>";